import { render } from "./coupon.vue?vue&type=template&id=c35dd5e2&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=c35dd5e2&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35dd5e2"]])

export default __exports__